module.exports = __webpack_public_path__ + "img/nodata.f899e938.png";